import { Input } from "@/components/ui/input";
import { Combobox } from "@/components/Combobox";
import { SectionLabel } from "./shiftUi";

const INTERNAL_TYPES = [{ value: "Training", label: "Staff Training" }, { value: "Office", label: "Office Shift" }];

export function ParticipantsBilling({ form, setForm, setLocOther, can, itemGroups, pOpts, pName, addParticipant, removeParticipant, splitParticipant, setPart }) {
  return (
    <>
      <SectionLabel>Participants &amp; Billing</SectionLabel>
      <label className="flex items-center gap-2 text-xs text-slate-700 mb-2" data-testid="no-participant-toggle-label">
        <input type="checkbox" checked={!!form.no_participant} disabled={!can.has("roster.edit")} data-testid="no-participant-toggle"
          onChange={(e) => {
            const on = e.target.checked;
            if (on) setLocOther?.(true);
            setForm((f) => ({ ...f, no_participant: on, internal_billing: "", participants: on ? [] : f.participants, sil_property: on ? "" : f.sil_property }));
          }} />
        No participants involved in this shift (Staff Training / Office)
      </label>
      {form.no_participant ? (
        <div>
          <label className="text-[10px] text-slate-500">Billing type</label>
          <select value={form.internal_billing} disabled={!can.has("roster.edit")} onChange={(e) => setForm((f) => ({ ...f, internal_billing: e.target.value }))}
            className="h-8 text-[11px] rounded-md border border-slate-200 bg-white px-1 w-full" data-testid="internal-billing">
            <option value="">Select…</option>
            {INTERNAL_TYPES.filter((t) => itemGroups.some((g) => g.name === t.value)).map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
          <div className="text-[10px] text-amber-600 mt-1">Billing off — internal shift. Clock in/out is still required.</div>
        </div>
      ) : (
      <div className="space-y-2">
        {form.participants.map((p, i) => {
          const g = itemGroups.find((x) => x.name === p.billing_type);
          return (
          <div key={i} className="rounded-md border border-slate-200 p-2.5 space-y-2" data-testid={`participant-row-${i}`}>
            <div className="flex items-center justify-between">
              <span className="text-xs font-semibold text-slate-800">{p.participant_name || pName(p.participant)}</span>
              {can.has("roster.edit") && (
                <div className="flex items-center gap-2">
                  <button type="button" onClick={() => splitParticipant(i)} className="text-brand text-[11px]" data-testid={`split-participant-${i}`}>+ Split billing</button>
                  <button type="button" onClick={() => removeParticipant(i)} className="text-red-500 text-[11px]" data-testid={`remove-participant-${i}`}>Remove</button>
                </div>
              )}
            </div>
            <div className="grid grid-cols-[1fr_70px] gap-2 items-end">
              <div>
                <label className="text-[10px] text-slate-500">Billing type</label>
                <select value={p.billing_type} disabled={!can.has("roster.edit")} onChange={(e) => setPart(i, "billing_type", e.target.value)} className="h-8 text-[11px] rounded-md border border-slate-200 bg-white px-1 w-full" data-testid={`participant-billing-${i}`}>
                  <option value="">Select…</option>
                  {itemGroups.map((x) => <option key={x.name} value={x.name}>{x.name}{x.sil_weekly ? " (SIL Weekly)" : x.sil ? " (SIL)" : ""}</option>)}
                </select>
              </div>
              <div>
                <label className="text-[10px] text-slate-500">Ratio 1:</label>
                <Input type="number" min="1" value={p.billing_ratio} disabled={!can.has("roster.edit")} onChange={(e) => setPart(i, "billing_ratio", Number(e.target.value))} className="h-8 text-[11px]" data-testid={`participant-ratio-${i}`} />
              </div>
            </div>
            {g && (g.sil_weekly || ["No Billing", "Training", "Office"].includes(g.name)) && (
              <div className="text-[10px] text-amber-600">Billing off for this participant{g.sil_weekly ? " (SIL Weekly — subscription)" : ""}.</div>
            )}
            <div className="grid grid-cols-2 gap-2">
              <div><label className="text-[10px] text-slate-500">From (blank = full)</label><Input type="time" value={p.from} disabled={!can.has("roster.edit")} onChange={(e) => setPart(i, "from", e.target.value)} className="h-8 text-[11px]" data-testid={`participant-from-${i}`} /></div>
              <div><label className="text-[10px] text-slate-500">To (blank = full)</label><Input type="time" value={p.to} disabled={!can.has("roster.edit")} onChange={(e) => setPart(i, "to", e.target.value)} className="h-8 text-[11px]" data-testid={`participant-to-${i}`} /></div>
            </div>
          </div>
          );
        })}
        {form.participants.length === 0 && <div className="text-[11px] text-red-500">Add at least one participant.</div>}
        {can.has("roster.edit") && <Combobox testid="field-participant" options={pOpts.filter((o) => !form.participants.some((p) => p.participant === o.value))} value={null} onChange={addParticipant} placeholder="+ Add participant" />}
        <div className="text-[10px] text-slate-400 leading-snug">Ratio auto-sets to the participant count; edit any row to override. To handle a participant leaving mid-shift, set their <b>To</b> time and change the remaining participant's ratio (or set the leaver's later portion to “No Billing”).</div>
      </div>
      )}
    </>
  );
}
